(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/actions/clear-items.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/actions/clear-items.js');
"use strict";


const clearItems = callback => (callbackFn, timeout) => {
  callback(undefined, callbackFn, timeout);
};
setGlobal('svs.components.selfserviceCart.fns.actions.clearItems', clearItems);

 })(window);